export const PagePatterns = {
    ROOT: "/",
    HOME: "/home",
    DAILY_TASK: "/daily-task",
    AUTH_SIGNIN: "/auth/signin",
    AUTH_SIGNUP: "/auth/signup",
    AUTH_SET_EMAIL: "/auth/set-email",
    AUTH_VERIFY_CODE: "/auth/verify-code",
    AUTH_SET_PASSWORD: "/auth/set-password",
    AUTH_LOADER: "/auth/loader",
    AUTH_FORGOT_PASS: "/auth/forgot-pass",
    PROFILE: "/profile",
    PROFILE_SETTINGS: "/profile/settings",
    PROFILE_SETTINGS_BILLING_HISTORY: "/profile/settings/billing-history",
    PROFILE_SETTINGS_BILLING_HISTORY_DETAILS: "/profile/settings/billing-history/details/:id",
    PROFILE_SETTINGS_SUBSCRIPTIONS: "/profile/settings/subscriptions",
    PROFILE_SETTINGS_SUBSCRIPTIONS_RENEW: "/profile/settings/subscriptions/renew",
    COURSES: "/courses",
    COURSE: "/course/:courseId",
    TOPIC: "/course/:courseId/topic/:topicId",
    LESSON: "/course/:courseId/topic/:topicId/lesson/:lessonId",
    CHALLENGES: "/challenges",
    CHALLENGES_FINISHED: "/challenges/finished",
    CHALLENGE: "/challenge/:courseId",
    STREAK: "/streak",
    AI_TOOLS: "/ai-tools",
    AI_TIPS: "/ai-tips",
    AI_TIP: "/ai-tips/:tipId",
    ONBOARDING: "/onboarding",
    ONBOARDING_ID: "/onboarding/:onboardingId",
    APP_ONBOARDING: "/app-onboarding",
    TERMS: "/terms",
    SUBSCRIPTION_TERMS: "/subscription-terms",
    PRIVACY: "/privacy",
    PAYMENT: "/payment",
    EXPERIMENT: "/experiment",
    EXPERIMENT_FAIL_PAYMENT: "/experiment/fail-payment",
    EXPERIMENT_SUCCESS_PAYMENT: "/experiment/success-payment",
    LUCK: "/luck",
    LUCK_PAYWALL: "/luck/paywall",
    LUCK_SET_EMAIL: "/luck/set-email",
    CREATOR: "/creator",
    CREATOR_PAYWALL: "/creator/paywall",
    CREATOR_SET_EMAIL: "/creator/set-email",
    ASSISTANT: "/assistant",
    UPSELL: "/upsell",
    LEARNING_PLAN: "/learning-plan",
    REVIEWS: "/reviews",
    REFUND_POLICY: "/refund-policy",
    PRICING: "/pricing",
    CONTACT: "/contact",
    ABOUT_US: "/about-us"
} as const;

export type PageTypeKey = keyof typeof PagePatterns;

export function patternToType(pattern: string): string {
    const segments = pattern.split("/").filter(Boolean);
    const staticSegments = segments.filter((s) => !s.startsWith(":") && !/^\d+$/.test(s));
    return staticSegments.join(".");
}

export const PageTypes: Record<PageTypeKey, string> = Object.keys(PagePatterns).reduce(
    (acc, key) => {
        const k = key as PageTypeKey;
        const type = patternToType(PagePatterns[k]);
        acc[k] = type || "root";
        return acc;
    },
    {} as Record<PageTypeKey, string>
);
